import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '~/app/core/components/confirm-dialog/confirm-dialog.component';
import { UxService, ValidationService } from '~/app/core/services';
import { DesignationListBaseComponent } from '~/app/open-age/directory/components/designation-list-base.component';
import { Division } from '~/app/open-age/directory/models';
import { DesignationService } from '~/app/open-age/directory/services';

@Component({
  selector: 'directory-designation-list',
  templateUrl: './designation-list.component.html',
  styleUrls: ['./designation-list.component.css']
})
export class DesignationListComponent extends DesignationListBaseComponent {
  @Input()
  view: 'table' | 'list' | 'grid' = 'table';
  dialogRef: any;
  constructor(public dialog: MatDialog,

              public validationService: ValidationService,
              public api: DesignationService,
              public uxService: UxService
  ) {
    super(api, uxService);
  }

  edit(department: Division, isEdit: boolean) {
    if (isEdit) {
      department.isEdit = true;
    } else {
      this.fetch();
      department.isEdit = false;
    }
  }

  save(item) {
    item.isEdit = false;
    this.update(item);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  openDialog(item): void {
    this.uxService.onConfirm({
      message: 'Are you sure you want to delete?'
    }).subscribe(() => {
      this.remove(item);
      this.uxService.showInfo('Deleted');
    });
  }
}
